import React, { useContext } from 'react'
import { UserContext } from '../../context/UserContext'
import {
  postApproveRegistration,
  postVerifyRegistration,
} from '../../services/dashboard.service'
import { toast } from 'react-toastify'
import { getApiErrorMessage } from '../../utils/error'

const StatusButton = ({ data, onUpdated = () => {} }) => {
  const { user } = useContext(UserContext)

  const onVerif = async () => {
    try {
      await postVerifyRegistration(data?.id)
      toast.success('Verifikasi sukses')
      // Kolom yang diubah endpoint ini sudah pasti, jadi barisnya ditambal
      // langsung. Kalau ternyata meleset, fetch berikutnya yang membetulkan.
      onUpdated(data?.id, { korwilApproval: true })
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Gagal memverifikasi pendaftaran'))
    }
  }

  const onApprove = async () => {
    try {
      await postApproveRegistration(data?.id)
      toast.success('Setujui sukses')
      onUpdated(data?.id, { centralApproval: true })
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Gagal menyetujui pendaftaran'))
    }
  }

  if (data.korwilApproval === null) {
    return (
      <button
        disabled={!['Master', 'Korwil'].includes(user?.role?.name)}
        className="btn btn-sm h-8 min-h-0 rounded-lg border-none normal-case text-[13px] font-semibold bg-[#059669] text-white hover:bg-[#047857] disabled:bg-subtle disabled:text-muted"
        onClick={(e) => {
          e.stopPropagation()
          onVerif()
        }}
      >
        Verifikasi
      </button>
    )
  } else if (data.korwilApproval === true && !data.centralApproval) {
    return (
      <button
        disabled={!['Master', 'PP'].includes(user?.role?.name)}
        className="btn btn-sm h-8 min-h-0 rounded-lg border-none normal-case text-[13px] font-semibold bg-[#F9813B] text-white hover:bg-[#E06E2C] disabled:bg-subtle disabled:text-muted"
        onClick={(e) => {
          e.stopPropagation()
          onApprove()
        }}
      >
        Setujui
      </button>
    )
  } else if (data.korwilApproval === true && data.centralApproval) {
    return (
      <button
        className="btn btn-sm h-8 min-h-0 rounded-lg border border-line normal-case text-[13px] font-semibold bg-subtle text-muted"
        disabled
      >
        Disetujui
      </button>
    )
  }
  return <></>
}

export default StatusButton
